import { events } from "@planzone/events";
import { updateNotification } from "./utils/updateNotification";
import { createStateReducer } from "../utils/createStateReducer";
import { initialState } from "./initialState";

const reduceRemoveProjectExternalLinkNotificationState = createStateReducer(
  initialState,
  {
    [events.removeProjectExternalLinkSucceeded]: (state) => ({
      ...state,
      queue: updateNotification(
        {
          key: "removeProjectExternalLink",
          flags: ["success"],
          args: { success: "true" },
        },
        state.queue,
      ),
    }),
    [events.removeProjectExternalLinkFailed]: (state) => ({
      ...state,
      queue: updateNotification(
        {
          key: "removeProjectExternalLink",
          flags: ["failure"],
          args: { failure: "true" },
        },
        state.queue,
      ),
    }),
  },
);

export { reduceRemoveProjectExternalLinkNotificationState };
